import type { Perfil } from './types';

/**
 * Espelho da tabela de permissões da API (api/src/lib/permissions.ts).
 * Serve só para mostrar/ocultar botões e menus: quem DECIDE é sempre a API, que valida cada chamada.
 * Se a tabela da API mudar, atualize aqui (há um teste que fixa o comportamento esperado).
 */
export type Permissao =
  | 'usuario:read' | 'usuario:write' | 'auditoria:read'
  | 'secretaria:read' | 'secretaria:write'
  | 'projeto:read' | 'projeto:write'
  | 'acao:read' | 'acao:write'
  | 'pesquisa:read' | 'pesquisa:write' | 'resposta:write'
  | 'painel:read' | 'integracao:write';

const TABELA: Record<Perfil, readonly Permissao[] | '*'> = {
  SUPERADMIN: '*',
  ADMIN_GESTOR: [
    'usuario:read', 'usuario:write', 'auditoria:read', 'secretaria:read', 'secretaria:write',
    'projeto:read', 'projeto:write', 'acao:read', 'acao:write', 'pesquisa:read', 'pesquisa:write', 'painel:read',
  ],
  SECRETARIO: ['secretaria:read', 'projeto:read', 'projeto:write', 'acao:read', 'acao:write', 'pesquisa:read', 'painel:read'],
  OPERADOR: ['secretaria:read', 'projeto:read', 'acao:read', 'acao:write', 'painel:read'],
  PESQUISADOR: ['resposta:write'],
  LEITOR: ['secretaria:read', 'projeto:read', 'acao:read', 'pesquisa:read', 'painel:read'],
};

export function pode(perfil: Perfil | undefined, permissao: Permissao): boolean {
  if (!perfil) return false;
  const t = TABELA[perfil];
  return t === '*' || t.includes(permissao);
}

export type Rota = 'painel' | 'impacto' | 'acoes' | 'projetos' | 'secretarias' | 'usuarios' | 'pesquisas' | 'auditoria' | 'dados';

export const MENU: { id: Rota; rotulo: string; permissao: Permissao }[] = [
  { id: 'painel', rotulo: 'Painel', permissao: 'painel:read' },
  { id: 'impacto', rotulo: 'Impacto', permissao: 'painel:read' },
  { id: 'acoes', rotulo: 'Ações', permissao: 'acao:read' },
  { id: 'projetos', rotulo: 'Projetos', permissao: 'projeto:read' },
  { id: 'secretarias', rotulo: 'Secretarias', permissao: 'secretaria:write' },
  { id: 'pesquisas', rotulo: 'Pesquisas', permissao: 'pesquisa:read' },
  { id: 'usuarios', rotulo: 'Usuários', permissao: 'usuario:read' },
  { id: 'auditoria', rotulo: 'Auditoria', permissao: 'auditoria:read' },
  { id: 'dados', rotulo: 'Dados oficiais', permissao: 'integracao:write' },
];

export const menuDoPerfil = (perfil: Perfil | undefined) => MENU.filter((m) => pode(perfil, m.permissao));
